import EmployeeListComponent from "../components/EmployeeList";
import useEmployeeList from "../hooks/useEmployeeList";

const EmployeeList = () => {
  const employeeListProps = useEmployeeList();
  return <EmployeeListComponent {...employeeListProps} />;
};

export default EmployeeList;
